import { Box, Button, Grid, Stack, TextField, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import login from "../../api/auth/login";
import useAuthStore from "../../stores/useAuthStore";
import { AccountCircle, Lock } from "@mui/icons-material";

export default function Landing() {
  const { setUser, setLoggedIn, setToken, setLoginError, setOrganization, setIsAdmin } = useAuthStore();
  const { register, handleSubmit } = useForm();

  const onSubmit = (values) => {
    login(values.email, values.password, (response, headers) => {
      console.log(headers);
      setLoginError(false);
      setLoggedIn(true);
      setToken(headers.authorization);
      setUser(response);
      setOrganization(response.organization);
      setIsAdmin(response.account_type === 'admin' || response.account_type === 'shared_admin');
      window.location = "/";
    });
  };

  return (
    <Stack>
      <Grid container height={{ xs: '80vh', sm: '100vh' }}>
        <Grid item xs={12} sm={5} bgcolor='primary.main' display={{ xs: 'none', sm: 'flex' }}>
        </Grid>
        <Grid item xs={12} sm={7} display="flex">
          <Stack justifyContent="center" mb={{ xs: 'auto' }} my={{ sm: 'auto' }} pt={{ xs: 10, sm: 0 }} width="100%">
            <Stack px={{ xs: "10%", sm: "15%" }} justifyContent={{ xs: 'center', sm: 'left' }}>
              <Stack justifyContent="center" width="100%" mb={10}>
                <Stack width={{ xs: '250px', sm: '350px' }} mx="auto">
                  <img src={require('../../images/logo.png')} />
                </Stack>
              </Stack>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Stack mb={2}>
                  <TextField
                    variant="standard"
                    label="Email"
                    placeholder="Email"
                    {...register('email')}
                    InputProps={{
                      startAdornment: <Box pr={1} display="flex">
                        <AccountCircle sx={{ my: 'auto !important' }} />
                      </Box>
                    }}
                    inputProps={{
                      sx: {
                        fontSize: '18px',
                        px: '10px',
                        borderRadius: '10px 10px 0 0'
                      }
                    }}
                  />
                </Stack>
                <Stack mb={4}>
                  <TextField
                    variant="standard"
                    type="password"
                    {...register('password')}
                    label="Password"
                    placeholder="Password"
                    InputProps={{
                      startAdornment: <Box pr={1} display="flex">
                        <Lock sx={{ my: 'auto !important' }} />
                      </Box>
                    }}
                    inputProps={{
                      sx: {
                        fontSize: '18px',
                        px: '10px'
                      }
                    }}
                  />
                </Stack>
                <Box width="100%" textAlign={{ xs: "center", sm: "right" }}>
                  <Button fullWidth sx={{ width: "220px", borderRadius: '100px' }} type="submit" variant="contained" color="primary">
                    <Typography fontWeight='700' color="#ffffff">
                      Login
                    </Typography>
                  </Button>
                </Box>
              </form>
            </Stack>
          </Stack>
        </Grid>
      </Grid>

    </Stack>
  );
}